var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBoxSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.62 13.2 2.79 8.09a.752.752 0 0 1-.27-1.03.75.75 0 0 1 1.03-.27L12 11.68l8.4-4.86a.76.76 0 0 1 1.03.27c.21.36.08.82-.27 1.03l-8.77 5.08a.94.94 0 0 1-.39.1c-.13 0-.26-.03-.38-.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.61v-9.07c0-.41.34-.75.75-.75s.75.34.75.75v9.07c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.559 22.17-5.34-2.96c-1.45-.8-2.59-2.73-2.59-4.39V9.16c0-1.66 1.14-3.58 2.59-4.39l5.34-2.96c1.36-.76 3.5-.76 4.87 0l5.34 2.96c1.45.8 2.59 2.73 2.59 4.39v3.66c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9.16c0-1.1-.85-2.54-1.81-3.07l-5.34-2.96c-.91-.51-2.5-.51-3.41 0l-5.34 2.96c-.97.54-1.81 1.97-1.81 3.07v5.66c0 1.1.85 2.54 1.81 3.07l5.34 2.96c.88.49 2.54.49 3.41 0 .36-.2.82-.07 1.02.29.2.36.07.82-.29 1.02-.66.38-1.53.59-2.44.59-.91 0-1.78-.21-2.44-.58z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 18.2c0-2.18 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95-3.95-1.77-3.95-3.95zm1.5 0c0 1.35 1.1 2.45 2.45 2.45s2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45-2.45 1.1-2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.47 22.53-1-1a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBoxSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-box-search.95a72f5e10725b34591fd0994005f6af.svg";
export { ForwardRef as ReactComponent };